module.exports = __webpack_public_path__ + "static/Home_Feature_3-e8efd0a520a0a0bc91a4bf27e9aebd74.jpg";